import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "~/common/mui";
import { ConfiguredProductCommerceControls } from "./ConfiguredProductCommerceControls";

interface ConfiguredProductAddToCartDialogProps {
  open: boolean;
  designation: string;
  priceText: string;
  quantity: number;
  priceReference: string;
  priceReferences: readonly { label: string; value: string }[];
  priceReferenceEditable: boolean;
  pending: boolean;
  error?: string;
  onQuantityChange: (quantity: number) => void;
  onPriceReferenceChange: (priceReference: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfiguredProductAddToCartDialog = ({
  open,
  designation,
  priceText,
  quantity,
  priceReference,
  priceReferences,
  priceReferenceEditable,
  pending,
  error,
  onQuantityChange,
  onPriceReferenceChange,
  onClose,
  onConfirm,
}: ConfiguredProductAddToCartDialogProps) => (
  <Dialog open={open} onClose={pending ? undefined : onClose} maxWidth="desktop-s" fullWidth>
    <DialogTitle>Add configured product to cart</DialogTitle>
    <DialogContent>
      <Stack gap={2}>
        <Typography variant="titleMedium">{designation}</Typography>
        <ConfiguredProductCommerceControls
          priceText={priceText}
          quantity={quantity}
          priceReference={priceReference}
          priceReferences={priceReferences}
          priceReferenceEditable={priceReferenceEditable}
          error={error}
          onQuantityChange={onQuantityChange}
          onPriceReferenceChange={onPriceReferenceChange}
        />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button variant="text" onClick={onClose} disabled={pending}>
        Cancel
      </Button>
      <Button onClick={onConfirm} loading={pending}>
        Add to cart
      </Button>
    </DialogActions>
  </Dialog>
);
